<template>
  <v-dialog v-model="letShowPopup" persistent max-width="650">
    <v-card class="pa-4">
      <v-card-title class="headline justify-center popup-title">
        Choose Custom Field
      </v-card-title>
      <v-card-text>
        <v-row class="mx-2 mb-8">
          <v-col cols="12">
            <v-data-table
              :headers="customFieldsTableHeaders"
              :items="filtredList"
              :page.sync="page"
              :items-per-page="5"
              item-key="id"
              hide-default-footer
              @page-count="pageCount = $event"
              class="cursor-point">

              <template v-slot:[`item.selected`]="{ item }">
                <v-simple-checkbox
                  v-model="item.selected"
                  color="#7972c0"
                  :ripple="false"/>
              </template>
              <template v-slot:[`item.name`]="{ item }">
                <div class="noteTruncate1">{{ item.name }}</div>
              </template>
              <template v-slot:[`item.description`]="{ item }">
                <div class="noteTruncate1">{{ item.fieldType }}</div>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
        <v-row class="justify-end" v-if='filtredList.length>5'>
          <v-col cols="auto">
            <v-pagination v-model="page" :length="pageCount" :total-visible="5" color="#7972C0"/>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions class="text-xs-center justify-center">
        <v-btn @click="cancel" depressed class="cancel-btn small-size">
          Cancel
        </v-btn>
        <v-btn @click="confirm" depressed class="save-btn small-size" :disabled='!haveSelected'>
          Confirm
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {
  MODULE_POPUP,
  SET_CUSTOM_FIELD_POPUP_SHOW
} from '@/store/constant/mutation-types'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'ChooseCustomField',
  props: {
    haveItems: {
      type: Array
    }
  },
  data() {
    return {
      customFieldsList: [],
      customFieldsTableHeaders: [
        {
          text: '',
          align: 'start',
          sortable: false,
          value: 'selected'
        },
        { text: 'Name', value: 'name', sortable: true, align: 'start' },
        { text: 'Type', value: 'fieldType', sortable: true, align: 'start' }
      ],
      page: 1,
      pageCount: 0,
      letShowPopup: true
    }
  },
  async created() {
    const fieldsList = await this.getCustomFieldsList({
      inventoryId: this.getActiveWarehouse?.id
    })
    this.customFieldsList = fieldsList.filter(item => {
      return item.active && item.applyTo !== 'ALL_ITEMS'
    })
    this.customFieldsList.forEach(cf => {
      cf.customFieldId = cf.id
    })
  },
  computed: {
    showPopup() {
      return this.$store.getters[`${MODULE_POPUP}/showChooseCustomFieldPopup`]
    },
    filtredList() {
      return this.customFieldsList.filter(cf => {
        return this.haveItems.indexOf(cf.customFieldId) === -1
      })
    },
    haveSelected() {
      return !!this.customFieldsList.filter(item => item.selected).length
    },
    ...mapGetters('warehouses', ['getActiveWarehouse'])
  },
  methods: {
    ...mapActions('customField', ['getCustomFieldsList']),
    confirm() {
      const selectedCustomFields = this.customFieldsList.filter(customField => customField.selected)
      this.$emit('selected-fields', selectedCustomFields)
      this.$store.commit(`${MODULE_POPUP}/${SET_CUSTOM_FIELD_POPUP_SHOW}`, false)
    },
    cancel() {
      this.$store.commit(`${MODULE_POPUP}/${SET_CUSTOM_FIELD_POPUP_SHOW}`, false)
    }
  }
}
</script>

<style>
.v-data-table-header, .v-data-footer {
  background-color: #f5f5f5;
}
</style>
